import React, { useEffect, useState } from "react";
import axios from "axios";
import HoSoCard from "./components/HoSoCard";
import LoadingSpinner from "./components/LoadingSpinner";
import ErrorMessage from "./components/ErrorMessage";

// API URL - Dùng relative path để Nginx reverse proxy xử lý
const API_URL = process.env.REACT_APP_API_URL || "/api";

// Configure axios defaults with security header
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

function App() {
  const [hoSoData, setHoSoData] = useState(null);
  const [baoGiaList, setBaoGiaList] = useState([]);
  const [thongBaoPhiList, setThongBaoPhiList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [qrId, setQrId] = useState(null);

  useEffect(() => {
    // Get QR ID from URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get("id");

    if (!id) {
      setError("Không tìm thấy mã QR trong URL. Vui lòng quét lại mã QR.");
      setLoading(false);
      return;
    }

    setQrId(id);
    fetchHoSoData(id);
  }, []);

  const fetchHoSoData = async (id) => {
    try {
      setLoading(true);
      setError(null);

      const response = await axios.get(`${API_URL}/hoso/${id}`, {
        timeout: 10000,
      });

      // console.log("[Frontend - App.jsx] API Response Data:", response.data);

      if (response.data.success) {
        const products = response.data.data;
        const extractedBaoGiaList = response.data.baoGiaList || [];
        const extractedThongBaoPhiList = response.data.thongBaoPhiList || [];

        // console.log(
        //   "[Frontend - App.jsx] Extracted baoGiaList:",
        //   extractedBaoGiaList,
        // );
        // console.log(
        //   "[Frontend - App.jsx] baoGiaList length:",
        //   extractedBaoGiaList.length,
        // );

        if (Array.isArray(products) && products.length > 0) {
          setHoSoData(products);
          setBaoGiaList(extractedBaoGiaList);
          setThongBaoPhiList(extractedThongBaoPhiList);
        } else {
          setError("Dữ liệu hồ sơ không hợp lệ");
        }
      } else {
        setError(response.data.message || "Không thể tải thông tin hồ sơ");
      }
    } catch (err) {
      console.error("Error fetching data:", err);

      if (err.code === "ECONNABORTED") {
        setError("Kết nối quá chậm. Vui lòng kiểm tra internet và thử lại.");
      } else if (err.response?.status === 404) {
        setError("Không tìm thấy hồ sơ với mã QR này. Vui lòng kiểm tra lại.");
      } else if (err.response?.status >= 500) {
        setError("Lỗi server. Vui lòng thử lại sau.");
      } else if (!err.response) {
        setError(
          "Không thể kết nối đến server. Vui lòng kiểm tra kết nối mạng.",
        );
      } else {
        setError("Đã xảy ra lỗi. Vui lòng thử lại sau.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRetry = () => {
    if (qrId) {
      fetchHoSoData(qrId);
    }
  };

  return (
    <div className="min-h-screen py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        {/* Responsive Branding Header */}
        <div className="flex flex-col items-center text-center mb-8">
          {/* Logo */}
          <div className="mb-2 md:mb-4">
            <img
              src="/LOGO-TQC.png"
              alt="Logo TQC"
              className="h-12 sm:h-14 md:h-16 lg:h-20 w-auto object-contain"
            />
          </div>
          {/* Text Lines with Controlled Line Break */}
          <div>
            <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-primary-main leading-snug text-center font-heading">
              TRUNG TÂM ĐO LƯỜNG <br className="block md:hidden" /> CHẤT LƯỢNG
              VIỄN THÔNG
            </h1>
          </div>
        </div>

        {/* Main Content */}
        <div className="bg-neutral-bgPaper rounded-lg-tqc shadow-lg-tqc overflow-hidden border border-neutral-borderAccent">
          {loading && <LoadingSpinner />}

          {error && <ErrorMessage message={error} onRetry={handleRetry} />}

          {!loading && !error && hoSoData && (
            <HoSoCard data={hoSoData} baoGiaList={baoGiaList} thongBaoPhiList={thongBaoPhiList} />
          )}
        </div>

        {/* Footer */}
        <div className="text-center mt-8 text-neutral-textSecondary text-sm font-body">
          <p>
            © {new Date().getFullYear()} Trung tâm Đo lường Chất lượng Viễn
            thông
          </p>
          <p className="mt-1 opacity-75">
            Hotline: 02439.436.608 hoặc 0888.058.928
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
